export function MessageCc({ emails }: { emails?: string[] }) {
  if (!emails?.length) return null;
  return <div className="message-cc"><span>Cc:</span><span>{emails.join(", ")}</span></div>;
}
